import { render } from "./CartIcon.vue?vue&type=template&id=3bd7e96f"
import script from "./CartIcon.vue?vue&type=script&lang=js"
export * from "./CartIcon.vue?vue&type=script&lang=js"

import "./CartIcon.vue?vue&type=style&index=0&id=3bd7e96f&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__